import { StyleSheet, View, TouchableOpacity, Image } from 'react-native';
import { Text, Colors } from '../components';
import { WebView } from 'react-native-webview';

const getReactNativeElements = (html_tags_array, web_link_action) => {
  let elements_array = [];
  let html_array     = html_tags_array || [];
  let cleaned_array  = getCleanedArray(html_array);
  let combined_text  = [];
  let HTML           = require('html-parse-stringify');

  let last_added_item = {};

  cleaned_array.forEach((item, i) => {

    let item_is_text        = item && item.type && item.type === 'text';
    let item_is_a           = item && item.name && item.name === 'a';
    let item_is_span        = item && item.name && item.name === 'span';

    let next_item_is_text   = cleaned_array.length > i + 1 && cleaned_array[i + 1] && (cleaned_array[i + 1].type === 'text' || cleaned_array[i + 1].name === 'a' || cleaned_array[i + 1].name === 'span');

    // =======================================================================================================
    // <ul & ol > ============================================================================================

    if (item.type === 'tag' && (item.name === 'ul' || item.name === 'ol')) {
      let list_elements = getListElements(item);
      elements_array.push(<View>{ list_elements }</View>)
    }

    // <ul & ol > ============================================================================================
    // =======================================================================================================

    // =======================================================================================================
    // <media:content > ======================================================================================

    if (item.type === 'tag' && item.name === 'media:content') {
      let image_obj    = getImageObject(item);
      let image_url    = image_obj.image_url;
      let image_credit = image_obj.image_credit;

      if (image_url) {
        elements_array.push(
          <View>
            <Image resizeMode='contain' style={{ width: '100%', height: 220, marginTop: 20, marginBottom: 20 }} source={{ uri: image_url }} />
          </View>
        );
      }
    }

    // <media:content > ======================================================================================
    // =======================================================================================================

    // =======================================================================================================
    // <center & iframe > ====================================================================================

    if (item.type === 'tag' && (item.name === 'center' || item.name === 'iframe')) {
      let html_conv = HTML.stringify([item])
      elements_array.push(<WebView
                            style={{ backgroundColor: 'pink', width: '100%', height: 315 }}
                            source={{ html: html_conv }}
                          />);
    }

    // <center & iframe > ====================================================================================
    // =======================================================================================================

    // =======================================================================================================
    // <br > =================================================================================================

    if (item.type === 'tag' && item.name === 'br') {
      elements_array.push(<View style={{ height: 15 }}></View>)
      last_added_item = item;
    }

    // <br > =================================================================================================
    // =======================================================================================================

    // =======================================================================================================
    // <Text> & <a> & <span> =================================================================================

    if ((item_is_text || item_is_a || item_is_span) && i > 0 ) {
      let text_element = getTextElement(item, null, null, web_link_action);

      if (next_item_is_text) {
        combined_text.push(getTextElement(item, null, null, web_link_action));
      } else if (combined_text.length > 0) {
        combined_text.push(getTextElement(item, null, null, web_link_action));
        elements_array.push(<Text>{ combined_text }</Text>)
        combined_text = [];
      } else {
        elements_array.push(<Text>{ text_element }</Text>)
      }
    }

    // <Text> & <a> & <span> =================================================================================
    // =======================================================================================================

    if (item.type === 'tag' && item.name === 'h3') {
      let text_element = getTextElement(item);
      elements_array.push(<Text>{ text_element }</Text>)
    }

    if (item.type === 'tag' && item.name === 'h2') {
      let text_element = getTextElement(item);
      elements_array.push(<Text>{ text_element }</Text>)
    }

  });

  return <View style={{ padding: 20, paddingTop: 0 }}>{ elements_array }</View>
}

const getTextElement = (text_object, font_size, color, web_link_action) => {
  if (text_object && text_object.type === 'tag' && text_object.name === 'span') {
    return getSpanElement(text_object);
  }

  if (text_object && text_object.type === 'tag' && text_object.name === 'a') {
    return getATagElement(text_object, font_size, web_link_action);
  }

  if (text_object && text_object.type === 'tag' && text_object.name === 'h3') {
    return getH3TagElement(text_object);
  }

  if (text_object && text_object.type === 'tag' && text_object.name === 'h2') {
    return getH2TagElement(text_object);
  }

  if (text_object && text_object.type === 'tag' && text_object.name === 'strong') {
    return getStrongTextElement(text_object, font_size, color);
  }

  let text_str = text_object && text_object.content;

  if (text_str.includes('&nbsp;')) {
    text_str = text_str.replace('&nbsp;', '');
  }

  if (text_str) {
    return <Text style={{ color: '#4F5575', fontSize: font_size || 18 }}>{ text_str }</Text>
  } else {
    return null;
  }
}

const getSpanElement = (span_object) => {
  let span_obj        = span_object || {};
  let is_child_text   = span_obj && span_obj.children && span_obj.children.length && span_obj.children[0] && span_obj.children[0].type === 'text' ? true : false;
  let text_element    = is_child_text ? getTextElement(span_obj.children[0]) : '';

  if (text_element) {
    return <Text>{ text_element }</Text>
  }
}

const getATagElement = (a_object, font_size, web_link_action) => {
  let a_url      = a_object && a_object.attrs && a_object.attrs.href;
  let a_text     = a_object && a_object.children && a_object.children.length && a_object.children[0] && a_object.children[0].type === 'text' ? a_object.children[0].content : '';
  let has_strong = a_object && a_object.children && a_object.children.length && a_object.children[0] && a_object.children[0].type === 'tag' && a_object.children[0].name === 'strong' ? true : false;

  if (has_strong) {
    a_text = getTextElement(a_object.children[0], font_size || 18, Colors.PRIMARY);
  }

  return <Text style={{ fontSize: font_size || 18, color: Colors.PRIMARY }}
               onPress={ () => {
                 if (web_link_action) {
                   web_link_action(a_url);
                 }
               }}>{ a_text }</Text>
}

const getH3TagElement = (h3_object) => {
  let h3_obj          = h3_object || {};
  let is_child_strong = h3_obj && h3_obj.children && h3_obj.children.length && h3_obj.children[0] && h3_obj.children[0].type === 'tag' && h3_obj.children[0].name === 'strong' ? true : false;
  let is_child_text   = h3_obj && h3_obj.children && h3_obj.children.length && h3_obj.children[0] && h3_obj.children[0].type === 'text' ? true : false;
  let text_element    = is_child_strong || is_child_text ? getTextElement(h3_obj.children[0], 20) : '';
  let multi_children  = h3_obj && h3_obj.children && h3_obj.children.length &&  h3_obj.children.length > 1 ? true : false;

  if (multi_children) {
    let text_child_array = [];

    h3_obj.children.forEach((child, i) => {
      let child_text_element = getTextElement(child, 20, '#4F5575');
      text_child_array.push(child_text_element);
    });

    text_element = [ ...text_child_array ];
  }

  return <View style={{ paddingTop: 18, paddingBottom: 8 }}><Text style={{ fontWeight: 'bold', fontSize: 20, color: '#4F5575' }}>{ text_element }</Text></View>
}

const getH2TagElement = (h3_object) => {
  let h3_obj          = h3_object || {};
  let is_child_strong = h3_obj && h3_obj.children && h3_obj.children.length && h3_obj.children[0] && h3_obj.children[0].type === 'tag' && h3_obj.children[0].name === 'strong' ? true : false;
  let is_child_text   = h3_obj && h3_obj.children && h3_obj.children.length && h3_obj.children[0] && h3_obj.children[0].type === 'text' ? true : false;
  let text_element    = is_child_strong || is_child_text ? getTextElement(h3_obj.children[0], 24) : '';

  return <View style={{ paddingBottom: 10, paddingTop: 10 }}><Text style={{ fontWeight: 'bold', fontSize: 24, color: '#4F5575' }}>{ text_element }</Text></View>
}

const getCleanedArray = (uncleaned_array) => {
  let arr                 = uncleaned_array || [];
  let cleaned_array       = [];
  let previous_added_item = {};

  arr.forEach((item, i) => {
    let is_empty_string   = item.type === 'text' && item.content && item.content === ' ';
    let back_to_back_br   = item.name && item.name === 'br' && previous_added_item && previous_added_item.name && previous_added_item.name === 'br';
    let is_p_type_element = item.name && item.name === 'p'  && item.children && item.children.length && item.children.length > 0;

    if (!is_empty_string && !back_to_back_br) {
      cleaned_array.push(item);
      previous_added_item = item;
    }

    if (is_p_type_element) {
      let p_children = item.children ? item.children : [];

      p_children.forEach((p_item) => {
        cleaned_array.push(p_item);
      });
    }
  });

  return cleaned_array;
}

const getImageObject = (media_object) => {
  let media_obj      = media_object || {};
  let media_children = media_obj.children || [];
  let image_url      = '';
  let image_credit   = '';

  media_children.forEach((child, i) => {
    let is_thumbnail = child && child.name && child.name === 'media:thumbnail';
    let is_image     = is_thumbnail && child.attrs && child.attrs.type && child.attrs.type.includes('image');
    let url          = is_image && child.attrs && child.attrs.url ? child.attrs.url : '';

    let is_credit    = child && child.name && child.name === 'media:credit';
    let credit_text  = child && child.children && child.children[0] && child.children[0].type === 'text' && child.children[0].content ? child.children[0].content : '';

    if (url) {
      image_url = url;
    }

    if (credit_text) {
      image_credit = credit_text;
    }
  });

  return { image_url, image_credit };
}

const getListElements = (list_object) => {
  let li_obj     = list_object     || {};
  let list_items = li_obj.children || [];

  let converted_items = [];

  list_items.forEach((item, i) => {
    let converted_text = getListItemElement(item);
    converted_items.push(<View>{ converted_text }</View>);
  });

  return <View>{ converted_items }</View>
}

const getListItemElement = (item) => {
  let list_item      = item || {};
  let item_children  = list_item.children || [];
  let combined_texts = [];

  item_children.forEach((child, i) => {
    let is_a      = child.type === 'tag'  && child.name === 'a';
    let is_strong = child.type === 'tag'  && child.name === 'strong';
    let is_h3     = child.type === 'tag'  && child.name === 'h3';
    let is_text   = child.type === 'text';

    if (is_a) {
      let a_text_element = getATagElement(child);
      combined_texts.push(a_text_element);
    }

    if (is_strong) {
      let strong_text_element = getStrongTextElement(child);
      combined_texts.push(strong_text_element);
    }

    if (is_h3) {
      let h3_text_element = getH3TagElement(child);
      combined_texts.push(h3_text_element);
    }

    if (is_text) {
      let text_str = child && child.content;
      if (text_str !== ' ') {
        let text_text_element = getTextElement(child);
        combined_texts.push(text_text_element);
      }
    }
  });

  return <Text>{ combined_texts }</Text>
}

const getStrongTextElement = (strong_obj, font_size, color_hex) => {
  let strong_text = strong_obj && strong_obj.children && strong_obj.children.length && strong_obj.children[0] && strong_obj.children[0].type === 'text' ? strong_obj.children[0].content : '';
  return <Text style={{ fontWeight: 'bold', color: color_hex || '#4F5575', fontSize: font_size || 16 }}>{ strong_text }</Text>
}

export default {
  getReactNativeElements,
}
